import React, { useRef, useEffect, useState } from 'react';
import axios from 'axios';

// Component to handle intersection observation and apply animations
const AnimatedOnScroll = ({ children, animationClass, delay = 0 }) => {
  const domRef = useRef();
  const [isVisible, setVisible] = useState(false);



  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setVisible(true);
        observer.unobserve(domRef.current);
      }
    }, {
      threshold: 0.5
    });

    if (domRef.current) {
      observer.observe(domRef.current);
    }

    return () => {
      if (domRef.current) {
        observer.unobserve(domRef.current);
      }
      observer.disconnect();
    };
  }, []);

  return (
    <div
      ref={domRef}
      className={`${isVisible ? animationClass : 'opacity-0 transform translate-y-4'} transition-all duration-700 ease-out`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

// AboutUsPage component with API integration
const AboutUsPage = () => {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [language, setLanguage] = useState('bn');

  const defaultBrands = [
    { name: 'Vim', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand21.png' },
    { name: 'Bashundhara', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand20.png' },
    { name: 'Dano', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand19.png' },
    { name: 'Xiaomi', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand18.png' },
    { name: 'Radhuni', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand17.png' },
    { name: 'Lux', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand16.png' },
    { name: 'Walton', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand15.png' },
    { name: 'Danish', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand14.png' },
    { name: 'Asus', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand13.png' },
    { name: 'Chashi', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand12.png' },
    { name: 'Rupchada', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand11.png' },
    { name: 'Garnier', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand10.png' },
    { name: 'Nestle', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand9.png' },
    { name: 'Horlicks', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand8.png' },
    { name: 'Wheel', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand7.png' },
    { name: 'Unilever', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand6.png' },
    { name: 'Lifeboy', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand5.png' },
    { name: 'Fresh', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand4.png' },
    { name: 'ACI', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand3.png' },
    { name: 'Teer', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand2.png' },
    { name: 'Diploma', image: 'https://react-easy-commere.easytechsolutions.xyz/img/compressed_brand_brand1.png' }
  ];

  // State update করুন
  const [brands, setBrands] = useState(defaultBrands);

  // useEffect এ API থেকে load করুন (না পেলে default থাকবে)
  useEffect(() => {
    const fetchAboutUsData = async () => {
      try {
        const response = await axios.get('https://aman-life-style-bd-main-server-974485829900.asia-south1.run.app/api/about-us');
        if (response.data.success) {
          setAboutData(response.data.aboutUs);
          // API থেকে brand data পেলে set করুন, না হলে default থাকবে
          if (response.data.aboutUs.brands && response.data.aboutUs.brands.length > 0) {
            setBrands(response.data.aboutUs.brands);
          }
        }
      } catch (err) {
        console.error('Error fetching About Us data:', err);
        setError('Failed to load About Us data');
        // Error হলেও default brands থাকবে
      } finally {
        setLoading(false);
      }
    };

    fetchAboutUsData();
  }, []);



  if (loading) {
    return (
      <div className="bg-white max-w-5xl mx-auto min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (error || !aboutData) {
    return (
      <div className="bg-white max-w-5xl mx-auto min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600">{error || 'Data not available'}</p>
        </div>
      </div>
    );
  }

  return (


    <div className="bg-white max-w-5xl mx-auto border border-gray-300 rounded-lg p-6 my-6">
      {/* Language Toggle Button */}
      {/* <div className="flex justify-end mb-4">
        <button
          onClick={() => setLanguage(language === 'bn' ? 'en' : 'bn')}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2"
        >
          <span>{language === 'bn' ? 'English' : 'বাংলা'}</span>
        </button>
      </div> */}
      {/* Header Section */}
      <div className="border-b border-gray-300 pb-4 mb-8">
        <AnimatedOnScroll animationClass="animate-fade-in-down">
          <h1 className="text-3xl md:text-4xl font-normal text-gray-900 mb-2">
            {aboutData.title}
          </h1>
          <p className="text-sm text-gray-600">
            {aboutData.subtitle}
          </p>
        </AnimatedOnScroll>
      </div>

      <div className="space-y-8">
        {/* Introduction */}
        <AnimatedOnScroll animationClass="animate-fade-in-up">
          <div className="bg-blue-50 border-l-4 border-blue-400 p-6">
            <p className="text-base text-gray-800 leading-relaxed">
              {aboutData.introduction}
            </p>
          </div>
        </AnimatedOnScroll>

        <AnimatedOnScroll animationClass="animate-fade-in-up" delay={100}>
          <p className="text-base text-gray-700 leading-relaxed">
            {aboutData.description}
          </p>
        </AnimatedOnScroll>

        {/* Our Mission */}
        <AnimatedOnScroll animationClass="animate-fade-in-left">
          <div className="border-b border-gray-200 pb-6">
            <h2 className="text-2xl font-medium text-gray-900 mb-4">
              Our Mission
            </h2>
            <div className="space-y-4">
              {aboutData.missionItems && aboutData.missionItems.map((mission, index) => (
                <AnimatedOnScroll
                  key={index}
                  animationClass="animate-fade-in-right"
                  delay={200 + (index * 100)}
                >
                  <div className="flex items-start space-x-3 bg-gray-50 p-4 rounded">
                    <span className="text-orange-600 text-xl flex-shrink-0 mt-1">✓</span>
                    <div>
                      <p className="font-semibold text-gray-900 mb-1">{mission.title}</p>
                      <p className="text-gray-700 text-sm">{mission.description}</p>
                    </div>
                  </div>
                </AnimatedOnScroll>
              ))}
            </div>
          </div>
        </AnimatedOnScroll>

        {/* Commitment Section */}
        <AnimatedOnScroll animationClass="animate-fade-in-up" delay={600}>
          <div className="bg-gray-50 p-6 rounded border border-gray-200">
            <p className="text-base text-gray-700 leading-relaxed mb-4">
              {aboutData.commitment}
            </p>
          </div>
        </AnimatedOnScroll>

        {/* Contact CTA */}
        <AnimatedOnScroll animationClass="animate-fade-in-up" delay={700}>
          <div className="bg-blue-50 border-l-4 border-blue-400 p-6">
            <p className="text-sm text-gray-700">
              {aboutData.contactCta}
            </p>
          </div>
        </AnimatedOnScroll>


        {/* Stats Section */}
        <AnimatedOnScroll animationClass="animate-fade-in-up" delay={800}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '24px',
            maxWidth: '1000px',
            margin: '40px auto 80px'
          }}>
            <div style={{
              textAlign: 'center',
              padding: '40px 32px',
              background: 'rgb(255, 255, 255)',
              borderRadius: '16px',
              border: '1px solid rgb(224, 224, 224)',
              boxShadow: 'rgba(0, 0, 0, 0.04) 0px 2px 8px',
              transition: '0.3s'
            }}>
              <div style={{
                fontSize: '48px',
                fontWeight: '700',
                background: 'linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                marginBottom: '12px'
              }}>
                {aboutData.stats?.yearsExperience || '10+'}
              </div>
              <div style={{ fontSize: '16px', fontWeight: '600', color: 'rgb(102, 102, 102)' }}>
                Years Experience
              </div>
            </div>

            <div style={{
              textAlign: 'center',
              padding: '40px 32px',
              background: 'rgb(255, 255, 255)',
              borderRadius: '16px',
              border: '1px solid rgb(224, 224, 224)',
              boxShadow: 'rgba(0, 0, 0, 0.04) 0px 2px 8px',
              transition: '0.3s'
            }}>
              <div style={{
                fontSize: '48px',
                fontWeight: '700',
                background: 'linear-gradient(135deg, rgb(240, 147, 251) 0%, rgb(245, 87, 108) 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                marginBottom: '12px'
              }}>
                {aboutData.stats?.happyCustomers || '50K+'}
              </div>
              <div style={{ fontSize: '16px', fontWeight: '600', color: 'rgb(102, 102, 102)' }}>
                Happy Customers
              </div>
            </div>

            <div style={{
              textAlign: 'center',
              padding: '40px 32px',
              background: 'rgb(255, 255, 255)',
              borderRadius: '16px',
              border: '1px solid rgb(224, 224, 224)',
              boxShadow: 'rgba(0, 0, 0, 0.04) 0px 2px 8px',
              transition: '0.3s'
            }}>
              <div style={{
                fontSize: '48px',
                fontWeight: '700',
                background: 'linear-gradient(135deg, rgb(79, 172, 254) 0%, rgb(0, 242, 254) 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                marginBottom: '12px'
              }}>
                {aboutData.stats?.productsCount || '100+'}
              </div>
              <div style={{ fontSize: '16px', fontWeight: '600', color: 'rgb(102, 102, 102)' }}>
                Products
              </div>
            </div>
          </div>
        </AnimatedOnScroll>


        {/* Brands Section */}
        <AnimatedOnScroll animationClass="animate-fade-in-up" delay={900}>
          <div style={{ marginTop: '60px', marginBottom: '40px' }}>
            <h2 className="text-2xl font-medium text-gray-900 mb-6 text-center">
              Our Trusted Brands
            </h2>
            <div style={{ position: 'relative', maxWidth: '100%' }}>
              {/* Left Scroll Button */}
              <button
                onClick={() => {
                  const container = document.getElementById('brands-container');
                  container.scrollBy({ left: -200, behavior: 'smooth' });
                }}
                style={{
                  position: 'absolute',
                  left: '-20px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '48px',
                  height: '48px',
                  background: 'linear-gradient(135deg, rgb(79, 172, 254) 0%, rgb(0, 242, 254) 100%)',
                  border: 'none',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  zIndex: 10,
                  boxShadow: 'rgba(79, 172, 254, 0.4) 0px 4px 16px',
                  transition: '0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                  e.currentTarget.style.boxShadow = 'rgba(79, 172, 254, 0.6) 0px 6px 20px';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                  e.currentTarget.style.boxShadow = 'rgba(79, 172, 254, 0.4) 0px 4px 16px';
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ color: 'rgb(255, 255, 255)' }}
                >
                  <path d="m15 18-6-6 6-6"></path>
                </svg>
              </button>

              {/* Brands Container */}
              <div
                id="brands-container"
                style={{
                  display: 'flex',
                  gap: '32px',
                  overflowX: 'auto',
                  scrollBehavior: 'smooth',
                  scrollbarWidth: 'none',
                  padding: '24px 0',
                  WebkitOverflowScrolling: 'touch'
                }}
              >
                {brands.map((brand, index) => (
                  <div
                    key={index}
                    style={{
                      minWidth: '160px',
                      height: '120px',
                      background: 'rgb(255, 255, 255)',
                      borderRadius: '12px',
                      border: '1px solid rgb(224, 224, 224)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '24px',
                      transition: '0.3s',
                      boxShadow: 'rgba(0, 0, 0, 0.04) 0px 2px 8px',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)';
                      e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.1) 0px 4px 12px';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0px)';
                      e.currentTarget.style.boxShadow = 'rgba(0, 0, 0, 0.04) 0px 2px 8px';
                    }}
                  >
                    <img
                      alt={brand.name}
                      src={brand.image}
                      style={{
                        maxWidth: '100%',
                        maxHeight: '60px',
                        objectFit: 'contain',
                        transition: '0.3s'
                      }}
                    />
                  </div>
                ))}
              </div>

              {/* Right Scroll Button */}
              <button
                onClick={() => {
                  const container = document.getElementById('brands-container');
                  container.scrollBy({ left: 200, behavior: 'smooth' });
                }}
                style={{
                  position: 'absolute',
                  right: '-20px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '48px',
                  height: '48px',
                  background: 'linear-gradient(135deg, rgb(79, 172, 254) 0%, rgb(0, 242, 254) 100%)',
                  border: 'none',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  zIndex: 10,
                  boxShadow: 'rgba(79, 172, 254, 0.4) 0px 4px 16px',
                  transition: '0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
                  e.currentTarget.style.boxShadow = 'rgba(79, 172, 254, 0.6) 0px 6px 20px';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                  e.currentTarget.style.boxShadow = 'rgba(79, 172, 254, 0.4) 0px 4px 16px';
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ color: 'rgb(255, 255, 255)' }}
                >
                  <path d="m9 18 6-6-6-6"></path>
                </svg>
              </button>
            </div>
          </div>
        </AnimatedOnScroll>

      </div>
    </div>
  );
};

export default AboutUsPage;